import { render, staticRenderFns } from "./ListSkeletonLoader.vue?vue&type=template&id=0657f8dc&scoped=true"
import script from "./ListSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./ListSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./ListSkeletonLoader.vue?vue&type=style&index=0&id=0657f8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657f8dc",
  null
  
)

export default component.exports